/* eslint-disable react/prop-types */
import React, { PropsWithChildren } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';

export class Scrollbar extends React.PureComponent<PropsWithChildren> {
    public displayName = 'Scrollbar';

    public override render() {
        return (
            <AutoSizer>
                {({ width, height }) => (
                    <div
                        className="scrollbar"
                        style={{
                            overflow: 'auto',
                            width,
                            height,
                        }}
                    >
                        {this.props.children}
                    </div>
                )}
            </AutoSizer>
        );
    }
}
